import { PageHeader } from '../layout/PageHeader';
import { ContentWrapper } from '../layout/styled';
import { AccontantOpOverviewTable } from './components/AccontantOpOverviewTable';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

export function AccountantOpOverview() {
  const isSmallScreen = useAtomValue(isSmallScreenState);

  return (
    <>
      <PageHeader
        title='Submitters Overview'
        description='Track monthly logged time per submitter'
        breadcrumbs={[{ title: 'Submitters Overview' }]}
      />
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <AccontantOpOverviewTable />
      </ContentWrapper>
    </>
  );
}
